import React, { Component } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { parse, format } from 'date-fns';
import classnames from 'classnames';
import photoPlaceholder from 'assets/images/user-photo-placeholder.svg';
import { getEquipmentColorClass } from '../../../../../../../../helpers/_helpers';
import styles from './styles';
import { connect } from 'react-redux';
import { dateSettingsFormat, globalBEDateFormat, TIME_FORMAT } from 'common/dateFormatConfig';
import { getTimeoffStartDate } from 'helpers/timeoff-date';

class UsedResources extends Component {
  getUsername = (user) => {
    if (!user) return '';
    return user.username;
  };

  getEquipmentInfo = (equipment, field) => {
    if (!equipment) return '';
    if (field === 'number') {
      return equipment.number || parseInt(equipment.name);
    }
    if (field === 'className') {
      return getEquipmentColorClass(equipment.color);
    }
    return equipment[field];
  };

  getDayNumber = (date) =>
    format(parse(date, globalBEDateFormat, new Date()), 'dd');

  getUserShift = (user) => {
    if (!user) return '';
    return user.profile.shifts.timeOfDay.toLowerCase();
  };

  getHolidayInfo = () => {
    const { holidays, event, type } = this.props;
    if (type !== 'people') return null;

    return holidays.find((h) => h.inDays.includes(event.dayNumber) && !h.isIndividual);
  };

  renderPartialStartTime = (timeoff) => {
    const { dateFormat, is12Format } = this.props;
    const start = getTimeoffStartDate(timeoff, dateFormat);
    if (!start) return null;
    const hour = is12Format ? format(start, 'h') : format(start, 'HH');
    const minute = format(start, 'mm');
    const amPm = is12Format ? format(start, 'a') : '';
    return (
      <>
        {hour}:{minute}
        <span>{amPm}</span>
      </>
    );
  };

  render() {
    const { classes, event, type, eventsWithIndividualHolidays } = this.props;

    return (
      <div
        className={classnames(
          classes.cellContent,
          this.getHolidayInfo() && classes.greenBackground
        )}
      >
        <div>
          <span className={classes.dayNumber}>{this.getDayNumber(event.dayNumber)}</span>
        </div>

        {this.getHolidayInfo() && (
          <div
            className={classnames(
              classes.holidayName,
              !eventsWithIndividualHolidays.length && classes.emptyCellHolidayName
            )}
          >
            {this.getHolidayInfo().name}
          </div>
        )}

        <div className={classes.list}>
          {type === 'people'
            ? eventsWithIndividualHolidays.map((timeoff) => (
                <div key={timeoff._id} className={classes.flexBox}>
                  <div className={classes.flexBoxInline}>
                    <div
                      className={classnames(
                        classes.userPhotoWrapper,
                        timeoff.isIndividual ? classes.individualUserBorder : classes[`${this.getUserShift(timeoff.user)}Border`]
                      )}
                    >
                      <img src={photoPlaceholder} alt="user photo" className={classes.userPhoto} />
                    </div>
                    <Typography
                      className={classnames(
                        classes.name,
                        (timeoff.type === 'full' || timeoff.isIndividual) && classes.fullWidth,
                        (timeoff.type !== 'full' && !timeoff.isIndividual) && classes.width1,
                        !timeoff.isIndividual ? classes[this.getUserShift(timeoff.user)] : null,
                        timeoff.isIndividual ? classes.individualUsername : null
                      )}
                    >
                      {this.getUsername(timeoff.user)}
                    </Typography>
                    {timeoff.type === 'partial' && (
                      <div className={classes.startTime}>
                        {this.renderPartialStartTime(timeoff)}
                      </div>
                    )}
                  </div>
                </div>
              ))
            : event.events.map((calendarEvent) => (
                <div key={calendarEvent._id} className={classes.flexBox}>
                  <div
                    className={classnames(
                      classes.equipmentBlock,
                      this.getEquipmentInfo(calendarEvent.equipment, 'className')
                    )}
                  >
                    <div
                      className={classes.equipmentNumber}
                      style={{ backgroundColor: this.getEquipmentInfo(calendarEvent.equipment, 'color') }}
                    >
                      {this.getEquipmentInfo(calendarEvent.equipment, 'number')}
                    </div>
                    <div
                      className={classes.equipmentName}
                      style={{ color: this.getEquipmentInfo(calendarEvent.equipment, 'color') }}
                    >
                      {this.getEquipmentInfo(calendarEvent.equipment, 'name')}
                    </div>
                  </div>
                </div>
              ))}
        </div>
      </div>
    );
  }
}

UsedResources.propTypes = {
  classes: propTypes.object.isRequired,
  event: propTypes.object.isRequired,
  type: propTypes.string.isRequired,
};

export default connect((state) => ({
  dateFormat: state.personalProfile.organization?.settings?.dateFormat,
  is12Format:
    (state.personalProfile.organization?.settings?.timeFormat ||
      state.kiosk?.company?.settings?.timeFormat ||
      TIME_FORMAT[0]) === TIME_FORMAT[0],
}))(withStyles(styles)(UsedResources));
